module.exports = __webpack_public_path__ + "img/logo_black.559d5cf9.webp";